<script setup lang="ts">
defineOptions({ inheritAttrs: false });
</script>
<template>
  <nut-cell-group class="mp-cell-group" v-bind="$attrs">
    <slot />
  </nut-cell-group>
</template>
<style lang="scss">
.mp-cell-group .nut-cell-group__wrap {
  margin: 0;
}
</style>
